import { render, staticRenderFns } from "./comment_popover.vue?vue&type=template&id=7dfe87c0"
import script from "./comment_popover.vue?vue&type=script&lang=js"
export * from "./comment_popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports